import React from "react";
import {
  createStyles,
  withStyles,
  WithStyles,
  StyleRules
} from "@material-ui/core/styles";
// ui
import ErrorIcon from "@material-ui/icons/Error";
import KnowbeButton from "@components/presentational/atoms/KnowbeButton";
// store
import { GetFacilityUsersResponse } from "@api/requests/facility/getFacilityUsers";
import {
  FACILITY_TYPE_KEIKAKUSODAN_SHOGAIJISODAN,
  TYPE_CONSULTATION_SHOGAIJISODAN
} from "@constants/mgr/KEIKAKUSODAN/variables";

const styles = (): StyleRules =>
  createStyles({
    li: {
      display: "flex",
      alignItems: "center",
      padding: "14px 16px",
      "&:nth-child(2n)": {
        backgroundColor: "#f5f5f5"
      }
    },
    userName: {
      margin: "0 auto 0 0",
      color: "rgba(0, 0, 0, 0.87)"
    },
    alertPeriod: {
      position: "relative"
    },
    alertIcon: {
      width: 14,
      height: 14,
      color: "#ffc416",
      position: "absolute",
      zIndex: 1,
      top: -7,
      right: -4
    },
    recordButton: {
      marginLeft: 8
    },
    w240Button: {
      marginLeft: 8,
      width: 240
    },
    disabledChild: {
      width: "47px",
      height: "20px",
      fontSize: "14px",
      lineHeight: 1.43,
      letterSpacing: "0.25px",
      textAlign: "center",
      color: "#3daa8d",
      marginRight: "6px"
    }
  });

type OwnProps = {
  user: GetFacilityUsersResponse["data"][number];
  facilitySubType: number | null;
};

type Props = OwnProps & WithStyles<typeof styles>;

const RecordEachUserCore = (props: Props): JSX.Element => {
  const { classes, user, facilitySubType } = props;
  return (
    <li className={classes.li}>
      <div className={classes.userName}>{user.displayName}</div>
      {facilitySubType === FACILITY_TYPE_KEIKAKUSODAN_SHOGAIJISODAN &&
        user.type_consultation === TYPE_CONSULTATION_SHOGAIJISODAN && (
          <span className={classes.disabledChild}>障害児</span>
        )}
      <KnowbeButton
        kind="outlineWhite"
        className={classes.recordButton}
        href={`#/record/support_plan/${user.uif_id}/assessment`}
      >
        アセスメント
      </KnowbeButton>
      <KnowbeButton
        kind="outlineWhite"
        className={classes.w240Button}
        href={`#/record/support_plan/${user.uif_id}/basic_info`}
      >
        申請者の現状（基本情報）
      </KnowbeButton>
      <div className={classes.alertPeriod}>
        {user.monitoring_not_create ? (
          <ErrorIcon className={classes.alertIcon} key={user.uif_id} />
        ) : null}
        <KnowbeButton
          kind="outlineWhite"
          className={classes.w240Button}
          href={`#/record/${user.uif_id}/plan_monitoring_meeting`}
        >
          計画・モニタリング・会議記録
        </KnowbeButton>
      </div>
      <KnowbeButton
        kind="outlineWhite"
        className={classes.recordButton}
        href={`#/record/${user.uif_id}/support`}
      >
        支援記録
      </KnowbeButton>
    </li>
  );
};

export const RecordEachUser = withStyles(styles)(RecordEachUserCore);
